<template>
  <!-- 数据统计时间筛选组件 -->
  <div class="page">
    <section class="info-wrap">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px">
        <el-form-item class="style" label="营业执照照片" prop="licenseCopy">
          <div class="img-wrap">
            <div class="img-list">
              <el-upload
                :class="ruleForm.licenseCopy && ruleForm.licenseCopy.length > 0 ? 'hide' : ''"
                list-type="picture-card"
                v-model="ruleForm.licenseCopy"
                :file-list="imgList"
                :action="$configUrl.uploadUrl"
                :on-remove="handleRemove"
                :on-success="
                  (response, file, fileList) => {
                    return handleAvatarSuccess(file, fileList);
                  }
                "
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
            <span class="labels-tips">营业执照请上传彩色照片 or 彩色扫描件 or 加盖公章鲜章的复印件</span>
          </div>
        </el-form-item>
        <el-form-item class="style" label="注册号" prop="licenseNumber">
          <el-input v-model="ruleForm.licenseNumber" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item label="商户名称" prop="businessLicenseInfoMerchantName">
          <div><el-input v-model="ruleForm.businessLicenseInfoMerchantName" placeholder="" clearable></el-input></div>
          <span v-if="id == 0" class="labels-tips"
            >若营业执照上商户名称为空或为“无”，请填写“个体户+经营者姓名”，如“个体户张三”</span
          >
        </el-form-item>
        <el-form-item v-if="id == 0" label="法人姓名" prop="businessLicenseInfoLegalPerson">
          <el-input v-model="ruleForm.businessLicenseInfoLegalPerson" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item v-if="id != 0" label="法人姓名" prop="certificateInfoLegalPerson">
          <el-input v-model="ruleForm.certificateInfoLegalPerson" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item v-if="id == 0" label="经营者姓名" prop="idCardName">
          <el-input v-model="ruleForm.idCardName" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item v-if="id != 0" class="style" prop="type" label="类型">
          <div>
            <el-radio-group v-model="ruleForm.type" @change="changeType">
              <el-radio :label="0">已三证合一</el-radio>
              <el-radio :label="1">未三证合一</el-radio>
            </el-radio-group>
          </div>
          <span class="labels-tips"
            >若营业执照注册号为18位统一社会信用代码，请选择“已三证合一”，否则请选择“未三证合一”</span
          >
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number || Boolean,
      default: false,
    },
    subjectData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      imgList: [],
      ruleForm: {
        licenseCopy: [],
        licenseNumber: '',
        businessLicenseInfoMerchantName: '',
        businessLicenseInfoLegalPerson: '',
        idCardName: '',
        type: 0,
      },
      rules: {
        type: [{ required: true, message: '', trigger: ['blur', 'change'] }],
        licenseCopy: [{ required: true, message: '请上传营业执照照片', trigger: ['blur', 'change'] }],
        licenseNumber: [{ required: true, message: '请输入注册号', trigger: ['blur', 'change'] }],
        businessLicenseInfoMerchantName: [{ required: true, message: '请输入商户名称', trigger: ['blur', 'change'] }],
        businessLicenseInfoLegalPerson: [{ required: true, message: '请输入法人姓名', trigger: ['blur', 'change'] }],
        idCardName: [{ required: true, message: '请输入经营者姓名', trigger: ['blur', 'change'] }],
      },
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
  },
  watch: {
    count: {
      handler: function () {
        this.validity();
      },
    },
    subjectData: {
      handler: function (data) {
        console.log(data);
        this.ruleForm = data.subjectDataVO;
        let licenseCopyList = data.subjectDataVO.licenseCopy.split(',');
        if (data.subjectDataVO.organizationCode != '') {
          this.ruleForm.type = 1;
        } else {
          this.ruleForm.type = 0;
        }
        this.changeType();
        this.imgList = licenseCopyList.map((item) => {
          const fileItem = {
            name: 'file',
            url: item,
            response: {
              data: item,
            },
          };
          return fileItem;
        });
      },
    },
  },

  methods: {
    handleAvatarSuccess(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.licenseCopy = file.response.data.url;
      console.log(this.ruleForm.licenseCopy);
      this.$emit('handleMediaId', this.ruleForm.licenseCopy,file.name);
    },
    handleRemove(file, fileList) {
      this.setImgurl(fileList);
    },
    setImgurl(fileList) {
      const result = [];
      for (let item of fileList) {
        console.log(item);
        item.size
          ? result.push({
              url: item.response.data,
            })
          : result.push({
              url: item.url,
            });
      }
      this.ruleForm.licenseCopy = result;
    },
    validity() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('confirm', { flag: true, ruleForm: this.ruleForm });
          console.log('验证通过');
        } else {
          this.$emit('confirm', { flag: false, ruleForm: this.ruleForm });
          console.log('验证失败');
          return false;
        }
      });
    },
    changeType() {
      this.$emit('changeType', this.ruleForm.type);
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.info-wrap {
  box-sizing: border-box;
  padding-left: 31px;
}
.img-wrap {
  width: 700px;
  .img-list {
    height: 58px;
    overflow: hidden;
  }
  .hint {
    font-size: 12px;
    transform-origin: left;
    transform: scale(0.9);
    color: #fe4b48;
    margin-bottom: 5px;
  }
  /deep/ .el-upload--picture-card {
    width: 58px;
    height: 58px;
    line-height: 58px;
  }
  /deep/ .el-upload-list {
    /deep/.el-upload-list__item.is-success:first-child {
      &::before {
        position: absolute;
        left: 0;
        top: 0;
        content: '主图';
        color: #fff;
        width: 100%;
        height: 22px;
        font-size: 12px;
        text-align: center;
        line-height: 22px;
        background: rgba(0, 0, 0, 0.36);
      }
    }
  }
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 58px;
    height: 58px;
    box-sizing: border-box;
  }
  /deep/ .el-upload--picture-card i {
    font-size: 14px;
  }
  /deep/ .el-upload-list__item-actions {
    width: 58px;
    height: 58px;
  }
  .hide {
    /deep/ .el-upload.el-upload--picture-card {
      display: none;
    }
  }
}
.labels-tips {
  font-size: 12px;
  font-weight: 500;
  color: #999999;
}
/deep/.el-input {
  width: 346px;
}
</style>
